import { render, staticRenderFns } from "./rolePermissions.vue?vue&type=template&id=7dd13c4f&"
import script from "./rolePermissions.vue?vue&type=script&lang=js&"
export * from "./rolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./rolePermissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports